const paliwo = { Benzyna: '', Diesel: '', Hybryda: '', Elektro: '', Gaz: '' }
export default paliwo